<template>
  <div class="d-flex flex-justify-center flex-align-center border border-radius-10 bg-darkCobalt fg-white c-pointer py-1
              px-5 bd-lightCobalt" id="btn_cupon" @click="crear_cupon()">
    <span><i class="fa-solid fa-tags mr-1"></i><span>Cupones de Puntos</span></span>
  </div>
</template>

<script>
import cuponPuntos from "@/components/puntos/cupon-puntos"

export default {
  methods: {
    crear_cupon: function (){
      this.$store.commit('PUSH_TO_FULL_MODAL_POSITIONS', window.scrollY)
      this.$FModal.show(
        {
          component: cuponPuntos,
          overlayStyles: {
            backgroundColor: 'rgba(12, 52, 161, 0.27)'
          },
          width: '100%',
          placement: 'center bottom',
          clickToClose: true,
        },
      )
    }
  },
}
</script>